import { IFluidObject } from '@fluidframework/core-interfaces';
import { PeopleService, Persona } from '@fluidx/office-fluid-types';
import { PostMessageSender, PostMessageHandlerFactory } from '../Shared/PostMessage';
import { OnResolveSuggestionsCalledMessage, OnResolveSuggestionsReturnedMessage, PairingValue } from '../MessageTypes';

export function getHostSidePeopleService(
  scope: IFluidObject
): {
  scopePairingValue?: PairingValue<Promise<PeopleService>>;
  scopeHandler?: PostMessageHandlerFactory;
} {
  const peopleServicePromise = scope.PeopleServicePromise;
  if (!peopleServicePromise) {
    return {};
  }

  return {
    scopePairingValue: { found: true },
    scopeHandler: (sender: PostMessageSender) => {
      return {
        ['OnResolveSuggestionsCalled']: async (message) => {
          const { filter } = (message as OnResolveSuggestionsCalledMessage).payload;
          let reply: OnResolveSuggestionsReturnedMessage;
          try {
            const result = await (await peopleServicePromise).onResolveSuggestions(filter);
            reply = {
              payload: { result }
            };
          } catch (e: any) {
            reply = {
              error: true,
              payload: e
            };
          }

          sender.sendReply(message, reply);
        }
      };
    }
  };
}

export function getGuestSidePeopleService(sender: PostMessageSender): Promise<PeopleService> {
  const PeopleServicePromise: Promise<PeopleService> = Promise.resolve({
    get PeopleService(): Promise<PeopleService> {
      return Promise.resolve(this);
    },
    onResolveSuggestions(filter?: string): Promise<Persona[]> {
      const message: OnResolveSuggestionsCalledMessage = {
        type: 'OnResolveSuggestionsCalled',
        payload: { filter }
      };
      return sender.sendWithReturn(message).then((reply) => {
        const payload = (reply as OnResolveSuggestionsReturnedMessage).payload;
        if (reply.error) {
          return Promise.reject(payload);
        }

        return payload.result;
      });
    }
  });
  return PeopleServicePromise;
}

// cspell:ignore UPNs
